import React, { useState, useEffect } from 'react';
import moment from 'moment';
import 'moment/locale/ro';

import Axios from 'axios';
import CountUp from 'react-countup';

import './App.scss';


function App() {

    const [data, setData] = useState();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await Axios.get('https://coronavirus-19-api.herokuapp.com/countries/romania');
                const { data } = response;
                setData(data);
            } catch (err) { }
        }
        fetchData();
    }, [])

    return (
        <div className="App">
            <div className="main-container">
                <div className="date">
                    <img src="https://www.countryflags.io/ro/flat/64.png" />
                    <span>{moment().format('llll')}</span>
                </div>
                <div className="totals">
                    <div className="total counter">
                        <span className="value"><CountUp end={data?.cases || 0} /></span>
                        <span className="label">cazuri confirmate</span>
                    </div>
                    <div className="new">
                        <div className="counter">
                            <span className="value"><CountUp end={data?.todayCases || 0} /></span>
                            <span className="label">cazuri noi</span>
                        </div>
                        <div className="counter">
                            <span className="value"><CountUp end={data?.todayDeaths || 0} /></span>
                            <span className="label">decese noi</span>
                        </div>
                    </div>
                </div>
                <div className="breakdown">
                    <div className="counter recovered">
                        <span className="value"><CountUp end={data?.recovered || 0} /></span>
                        <span className="label">vindecati</span>
                    </div>
                    <div className="counter critical">
                        <span className="value"><CountUp end={data?.critical || 0} /></span>
                        <span className="label">in stare grava</span>
                    </div>
                    <div className="counter deaths">
                        <span className="value"><CountUp end={data?.deaths || 0} /></span>
                        <span className="label">decese</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default App;
